import { gql } from '@apollo/client';
import { FUNDER } from '../fragments';

export const FILTERED_FUNDERS_BY_SP_PROGRAMMES = gql`
  query FilteredFundersBySPProgrammes($input: AllFundersInput!) {
    funders: filteredFundersBySPProgrammes(input: $input) {
      ...funder
    }
  }
  ${FUNDER}
`;
